import { ReactElement } from 'react';
import WalletSwap from './WalletSwap';
import PayTicket from './PayTicket';
import { useWallet } from '@/services';
const SandboxModal = (): ReactElement => {
    const { logged } = useWallet();
    if (!logged) {
        return <></>;
    }
    return (
        <>
            <WalletSwap />
            <PayTicket />
        </>
    );
};

export default SandboxModal;
